import { Grid } from '@material-ui/core'
import { FormInputText } from '../../../dsn-kernel'
import React from 'react'
import { Parametre } from '../../../store/constants/fonction/parametre'
import { useForm } from 'react-hook-form'
import { createParametre, updateParametre } from '../../../store/actions/fonction/parametre-action'
import { useDispatch } from 'react-redux'
import { ValidationButton } from '../../common/validation-button'
import { CancelButton } from '../../common/cancel-button'
import { ChoixType } from '../ChoixType'

export const CreationParametre = ({ classes, toEdit, handleClose }) => {
  const dispatch = useDispatch()
  const useFormObj = useForm({
    values: toEdit ? toEdit : new Parametre(),
  })

  const handleCancel = () => {
    handleClose()
  }
  const handleSaveParametre = data => {
    const dataToSave = { ...data }
    if (dataToSave.referenceObj && dataToSave.referenceObj.nom) {
      dataToSave.reference = dataToSave.referenceObj.nom
      delete dataToSave.referenceObj
    }
    if (toEdit) {
      dataToSave.nom = toEdit.nom
      dispatch(updateParametre(dataToSave))
    } else {
      dispatch(createParametre(dataToSave))
    }
  }
  return (
    <>
      <Grid item xs={12} style={{ marginTop: 15, marginBottom: 15 }}>
        <FormInputText
          label={'Nom de la fonction'}
          name="nom"
          control={useFormObj.control}
          rules={{ required: true }}
          disabled={!!toEdit}
        />
        <ChoixType classes={classes} useFormObj={useFormObj} />
        <FormInputText
          label={'Description'}
          name="description"
          control={useFormObj.control}
          rules={{ required: true }}
          multiline
          rows={4}
        />
      </Grid>
      <Grid>
        <ValidationButton
          variant="contained"
          size="medium"
          color="primary"
          onClick={useFormObj.handleSubmit(handleSaveParametre)}
          className={classes.margin}
        >
          ENREGISTRER
        </ValidationButton>
      </Grid>
      <Grid>
        <CancelButton
          variant="contained"
          size="medium"
          color="primary"
          onClick={handleCancel}
          className={classes.margin}
        >
          ANNULER
        </CancelButton>
      </Grid>
    </>
  )
}
